import React from "react";

import queryString from "query-string";

const MainTitle = ({ title }) => {
  const handleTitleSize = () => {
    return title && title.length > 40 && "small-size";
  };

  return <p className={`header ${handleTitleSize()}`}>{title ? title : ""}</p>;
};

export default MainTitle;
